<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <span>
  </span>
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div class="card-part pt-0">
          <div>
            <div class="mb-3">
              <span class="black--text txt-head">1. หลักการและเหตุผล</span>
              <span
                class="theme-color-seven txt-normal"
                style="text-indent: 16px"
                >(โปรดระบุ)</span
              >
            </div>
            <Wysiwyg
              theme="3"
              :readonly="isOIC"
              height="250"
              :value="form.principle"
              @onChange="setFormField('principle', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">2. วัตถุประสงค์</span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.objective"
            @onChange="setFormField('objective', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head">
              3. ผู้รับบริการ/กลุ่มเป้าหมาย/สาขาอุตสาหกรรม
            </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.industry_group"
            @onChange="setFormField('industry_group', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"> 4. เป้าหมาย </span>
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <Wysiwyg
            theme="3"
            :readonly="isOIC"
            height="250"
            :value="form.target"
            @onChange="setFormField('target', $event)"
          ></Wysiwyg>
        </div>
      </div>
    </divcard>


    <divcard>
      <div class="card-part pt-0">
        <div>
          <span class="black--text txt-head"> 5. รายละเอียดโครงการ </span>
          <div class="mb-3">
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <span>{{
            "1) กิจกรรมบริหารจัดการและพัฒนาเครือข่ายการดําเนินงานอุทยานวิทยาศาสตร์ภูมิภาค (RSP Management)"
          }}</span>
        </div>
        <!-- 5.1 -->
        <div class="card-part">
          <div class="d-flex justify-end mb-5">
            <Button
              :disabled="editMode1 || isOIC"
              @onClick="addActivity1"
              theme="500"
              prepend-icon="mdi-plus"
              >เพิ่มกิจกรรม</Button
            >
          </div>
          <div class="card-part">
          
            <div
              v-if="form.step5_1.length > 0"
              class="d-flex flex-column gap-12"
            >
              <divcard
                v-for="(item, i) in form.step5_1"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{ highlighted: item.expandedForm5_1 }"
                :style="{ order: item.expandedForm5_1 ? 'orange' : 'initial' }"
                @onClick="item.expandedForm5_1 = !item.expandedForm5_1"
              >
                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="editActivity1(i)"
                  >
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>

                <div
                  class="txt-bigger flex flex-col"
                  style="min-width: 20%; max-width: 20%"
                >
                  <div>กิจกรรม</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_1 }"
                  >
                    <div>วันที่จัดกิจกรรม</div>
                    <div>สถานที่</div>
                    <div>วิทยากร</div>
                    <div>ผู้เข้าร่วม</div>
                    <div>รายละเอียดกิจกรรม</div>
                    <div>การอัพโหลดรูปภาพ</div>
                  </div>
                </div>
                <div
                  class="flex flex-col txt-bigger2"
                  style="min-width: 70%; max-width: 70%"
                >
                  <div>{{ item?.name ?? "-" }}</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_1 }"
                  >
                    <div>{{ item?.date ?? "-" }}</div>
                    <div>{{ item?.location ?? "-" }}</div>
                    <div>{{ item?.lecturer ?? "-" }}</div>
                    <div>{{ item?.participant ?? "-" }}</div>
                    <div>{{ item?.description ?? "-" }}</div>
                    <div>
                      {{
                        item?.attachment?.name ||
                        item?.attachment?.file_name ||
                        "-"
                      }}
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="deleteActivity1(i)"
                  >
                    <Iconify
                      icon="mdi:close-circle"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
              </divcard>
            </div>
            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
          <div v-if="editMode1" class="pt-6">
            <div>
              <div>
                <div class="mb-1 black--text">กิจกรรม</div>
                <TextField
                  theme="3"
                  :value="activity1New.name"
                  @onChange="activity1New.name = $event"
                >
                </TextField>
              </div>

              <div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">วันที่จัดกิจกรรม</div>
                    <DatePicker
                      theme="3"
                      input-type="number"
                      :value="activity1New.date"
                      @onInput="
                        activity1New.date = $event;
                        $forceUpdate();
                      "
                    >
                    </DatePicker>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">สถานที่</div>
                    <TextField
                      theme="3"
                      :value="activity1New.location"
                      @onChange="activity1New.location = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">วิทยากร</div>
                    <TextField
                      theme="3"
                      :value="activity1New.lecturer"
                      @onChange="activity1New.lecturer = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">ผู้เข้าร่วม</div>
                    <TextField
                      theme="3"
                      :value="activity1New.participant"
                      @onChange="activity1New.participant = $event"
                    >
                    </TextField>
                  </div>
                </div>
              </div>

              <div>
                <div class="mb-1 black--text">รายละเอียดกิจกรรม</div>
                <TextArea
                  theme="3"
                  height="100"
                  :value="activity1New.description"
                  @onChange="activity1New.description = $event"
                ></TextArea>
              </div>

              <div class="mb-1 black--text">การอัพโหลดรูปภาพ</div>
              <div class="theme-color-seven mb-3">
                *ไฟล์ที่ระบบรองรับ .PNG (สูงสุด 50 mb/ไฟล์)
              </div>
              <v-layout class="mt-3">
                <template
                  v-if="
                    !activity1New.attachment?.doc_type ||
                    activity1New.attachment?.doc_type === null
                  "
                >
                  <v-flex xs7>
                    <v-file-input
                      :id="'file'"
                      :rules="rulesFile"
                      color="#F15A29"
                      :clearable="false"
                      style="border-radius: 30px"
                      outlined
                      height="36"
                      placeholder=""
                      prepend-icon=""
                      accept="image/png"
                      v-show="
                        checkValType(activity1New?.attachment?.file_name) ==
                          'object' ||
                        activity1New?.attachment?.file_name == '' ||
                        activity1New?.attachment?.file_name == null
                      "
                      v-model="files1"

                      @change="addToAttachment1(files1)"
                    ></v-file-input>
                    <v-text-field
                      v-show="
                        checkValType(activity1New?.attachment?.file_name) ==
                        'string'
                      "
                      v-model="activity1New.attachment.file_name"
                      outlined
                      height="36"
                      color="#F15A29"
                      style="border-radius: 30px"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      dark
                      rounded
                      width="100"
                      color="#464647"
                      @click="selectFile1()"
                    >
                      <v-icon class="font-12 font-w-700" left
                        >mdi-upload</v-icon
                      >
                      <span class="font-12 font-w-700">อัพโหลด</span>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      height="35"
                      width="35"
                      fab
                      dark
                      color="#FD0C0C"
                      @click="removeFile1()"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </div>
            <div class="d-flex justify-end gap-16">
              <Button min-width="80px" theme="2" @onClick="editMode1 = false"
                >ยกเลิก
              </Button>

              <Button min-width="80px" theme="6" @onClick="saveActivity1"
                >ยืนยัน
              </Button>
            </div>
          </div>
        </div>
        <!-- 5.2 -->
        <div class="card-part">
          <span>{{
            "2) กิจกรรมส่งเสริมกลยุทธ์การสร้างความตระหนักและเผยแพร่ภาพลักษณ์ของอุทยานวิทยาศาสตร์ภูมิภาค(RSP Branding)"
          }}</span>
          <div class="d-flex justify-end mb-5">
            <Button
              :disabled="editMode2 || isOIC"
              @onClick="addActivity2"
              theme="500"
              prepend-icon="mdi-plus"
              >เพิ่มกิจกรรม</Button
            >
          </div>
          <div class="card-part">
            <div
              v-if="form.step5_2 && form.step5_2.length > 0"
              class="d-flex flex-column gap-12"
            >
              <divcard
                v-for="(item, i) in form.step5_2"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{ highlighted: item.expandedForm5_2 }"
                :style="{ order: item.expandedForm5_2 ? 'orange' : 'initial' }"
                @onClick="item.expandedForm5_2 = !item.expandedForm5_2"
              >
                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="editActivity2(i)"
                  >
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>

                <div
                  class="txt-bigger flex flex-col"
                  style="min-width: 20%; max-width: 20%"
                >
                  <div>กิจกรรม</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_2 }"
                  >
                    <div>วันที่จัดกิจกรรม</div>
                    <div>สถานที่</div>
                    <div>วิทยากร</div>
                    <div>ผู้เข้าร่วม</div>
                    <div>รายละเอียดกิจกรรม</div>
                    <div>การอัพโหลดรูปภาพ</div>
                  </div>
                </div>
                <div
                  class="flex flex-col txt-bigger2"
                  style="min-width: 70%; max-width: 70%"
                >
                  <div>{{ item?.name ?? "-" }}</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_2 }"
                  >
                    <div>{{ item?.date ?? "-" }}</div>
                    <div>{{ item?.location ?? "-" }}</div>
                    <div>{{ item?.lecturer ?? "-" }}</div>
                    <div>{{ item?.participant ?? "-" }}</div>
                    <div>{{ item?.description ?? "-" }}</div>
                    <div>
                      {{
                        item?.attachment?.name ||
                        item?.attachment?.file_name ||
                        "-"
                      }}
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="deleteActivity2(i)"
                  >
                    <Iconify
                      icon="mdi:close-circle"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
              </divcard>
            </div>
            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
          <div v-if="editMode2" class="pt-6">
            <div>
              <div>
                <div class="mb-1 black--text">กิจกรรม</div>
                <TextField
                  theme="3"
                  :value="activity2New.name"
                  @onChange="activity2New.name = $event"
                >
                </TextField>
              </div>

              <div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">วันที่จัดกิจกรรม</div>
                    <DatePicker
                      theme="3"
                      input-type="number"
                      :value="activity2New.date"
                      @onInput="
                        activity2New.date = $event;
                        $forceUpdate();
                      "
                    >
                    </DatePicker>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">สถานที่</div>
                    <TextField
                      theme="3"
                      :value="activity2New.location"
                      @onChange="activity2New.location = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">วิทยากร</div>
                    <TextField
                      theme="3"
                      :value="activity2New.lecturer"
                      @onChange="activity2New.lecturer = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">ผู้เข้าร่วม</div>
                    <TextField
                      theme="3"
                      :value="activity2New.participant"
                      @onChange="activity2New.participant = $event"
                    >
                    </TextField>
                  </div>
                </div>
              </div>

              <div>
                <div class="mb-1 black--text">รายละเอียดกิจกรรม</div>
                <TextArea
                  theme="3"
                  height="100"
                  :value="activity2New.description"
                  @onChange="activity2New.description = $event"
                ></TextArea>
              </div>

              <div class="mb-1 black--text">การอัพโหลดรูปภาพ</div>
              <div class="theme-color-seven mb-3">
                *ไฟล์ที่ระบบรองรับ .PNG (สูงสุด 50 mb/ไฟล์)
              </div>

              <v-layout class="mt-3">
                <template
                  v-if="
                    !activity2New.attachment?.doc_type ||
                    activity2New.attachment?.doc_type === null
                  "
                >
                  <v-flex xs7>
                    <v-file-input
                      v-model="files2"
                      :id="'file2'"
                      :rules="rulesFile"
                      color="#F15A29"
                      :clearable="false"
                      style="border-radius: 30px"
                      outlined
                      height="36"
                      placeholder=""
                      prepend-icon=""
                      accept="image/png"
                      v-show="
                        checkValType(activity2New?.attachment?.file_name) ==
                          'object' ||
                        activity2New?.attachment?.file_name == '' ||
                        activity2New?.attachment?.file_name == null
                      "
                      @change="addToAttachment2(files2)"
                    ></v-file-input>
                    <v-text-field
                      v-show="
                        checkValType(activity2New?.attachment?.file_name) ==
                        'string'
                      "
                      v-model="activity2New.attachment.file_name"
                      outlined
                      height="36"
                      color="#F15A29"
                      style="border-radius: 30px"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      dark
                      rounded
                      width="100"
                      color="#464647"
                      @click="selectFile2()"
                    >
                      <v-icon class="font-12 font-w-700" left
                        >mdi-upload</v-icon
                      >
                      <span class="font-12 font-w-700">อัพโหลด</span>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      height="35"
                      width="35"
                      fab
                      dark
                      color="#FD0C0C"
                      @click="removeFile2()"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </div>
            <div class="d-flex justify-end gap-16">
              <Button min-width="80px" theme="2" @onClick="editMode2 = false"
                >ยกเลิก
              </Button>

              <Button min-width="80px" theme="6" @onClick="saveActivity2"
                >ยืนยัน
              </Button>
            </div>
          </div>
        </div>
        <!-- 5.3 -->
        <div class="card-part">
          <span>{{
            "3) กิจกรรมพัฒนาทักษะและศักยภาพเบื้องต้นบุคลากรอุทยานวิทยาศาสตร์ภูมิภาค (RSP Skill up)"
          }}</span>
          <div class="d-flex justify-end mb-5">
            <Button
              :disabled="editMode3 || isOIC"
              @onClick="addActivity3"
              theme="500"
              prepend-icon="mdi-plus"
              >เพิ่มกิจกรรม</Button
            >
          </div>
          <div class="card-part">
            <div
              v-if="form.step5_3 && form.step5_3.length > 0"
              class="d-flex flex-column gap-12"
            >
              <divcard
                v-for="(item, i) in form.step5_3"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{ highlighted: item.expandedForm5_3 }"
                :style="{ order: item.expandedForm5_3 ? 'orange' : 'initial' }"
                @onClick="item.expandedForm5_3 = !item.expandedForm5_3"
              >
                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="editActivity3(i)"
                  >
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>

                <div
                  class="txt-bigger flex flex-col"
                  style="min-width: 20%; max-width: 20%"
                >
                  <div>กิจกรรม</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_3 }"
                  >
                    <div>วันที่จัดกิจกรรม</div>
                    <div>สถานที่</div>
                    <div>วิทยากร</div>
                    <div>ผู้เข้าร่วม</div>
                    <div>รายละเอียดกิจกรรม</div>
                    <div>การอัพโหลดรูปภาพ</div>
                  </div>
                </div>
                <div
                  class="flex flex-col txt-bigger2"
                  style="min-width: 70%; max-width: 70%"
                >
                  <div>{{ item?.name ?? "-" }}</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_3 }"
                  >
                    <div>{{ item?.date ?? "-" }}</div>
                    <div>{{ item?.location ?? "-" }}</div>
                    <div>{{ item?.lecturer ?? "-" }}</div>
                    <div>{{ item?.participant ?? "-" }}</div>
                    <div>{{ item?.description ?? "-" }}</div>
                    <div>
                      {{
                        item?.attachment?.name ||
                        item?.attachment?.file_name ||
                        "-"
                      }}
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="deleteActivity3(i)"
                  >
                    <Iconify
                      icon="mdi:close-circle"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
              </divcard>
            </div>
            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
          <div v-if="editMode3" class="pt-6">
            <div>
              <div>
                <div class="mb-1 black--text">กิจกรรม</div>
                <TextField
                  theme="3"
                  :value="activity3New.name"
                  @onChange="activity3New.name = $event"
                >
                </TextField>
              </div>

              <div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">วันที่จัดกิจกรรม</div>
                    <DatePicker
                      theme="3"
                      input-type="number"
                      :value="activity3New.date"
                      @onInput="
                        activity3New.date = $event;
                        $forceUpdate();
                      "
                    >
                    </DatePicker>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">สถานที่</div>
                    <TextField
                      theme="3"
                      :value="activity3New.location"
                      @onChange="activity3New.location = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">วิทยากร</div>
                    <TextField
                      theme="3"
                      :value="activity3New.lecturer"
                      @onChange="activity3New.lecturer = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">ผู้เข้าร่วม</div>
                    <TextField
                      theme="3"
                      :value="activity3New.participant"
                      @onChange="activity3New.participant = $event"
                    >
                    </TextField>
                  </div>
                </div>
              </div>

              <div>
                <div class="mb-1 black--text">รายละเอียดกิจกรรม</div>
                <TextArea
                  theme="3"
                  height="100"
                  :value="activity3New.description"
                  @onChange="activity3New.description = $event"
                ></TextArea>
              </div>

              <div class="mb-1 black--text">การอัพโหลดรูปภาพ</div>
              <div class="theme-color-seven mb-3">
                *ไฟล์ที่ระบบรองรับ .PNG (สูงสุด 50 mb/ไฟล์)
              </div>

              <v-layout class="mt-3">
                <template
                  v-if="
                    !activity3New.attachment?.doc_type ||
                    activity3New.attachment?.doc_type === null
                  "
                >
                  <v-flex xs7>
                    <v-file-input
                      v-model="files3"
                      :id="'file3'"
                      :rules="rulesFile"
                      color="#F15A29"
                      :clearable="false"
                      style="border-radius: 30px"
                      outlined
                      height="36"
                      placeholder=""
                      prepend-icon=""
                      accept="image/png"
                      v-show="
                        checkValType(activity3New?.attachment?.file_name) ==
                          'object' ||
                        activity3New?.attachment?.file_name == '' ||
                        activity3New?.attachment?.file_name == null
                      "
                      @change="addToAttachment3(files3)"
                    ></v-file-input>
                    <v-text-field
                      v-show="
                        checkValType(activity3New?.attachment?.file_name) ==
                        'string'
                      "
                      v-model="activity3New.attachment.file_name"
                      outlined
                      height="36"
                      color="#F15A29"
                      style="border-radius: 30px"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      dark
                      rounded
                      width="100"
                      color="#464647"
                      @click="selectFile3()"
                    >
                      <v-icon class="font-12 font-w-700" left
                        >mdi-upload</v-icon
                      >
                      <span class="font-12 font-w-700">อัพโหลด</span>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      height="35"
                      width="35"
                      fab
                      dark
                      color="#FD0C0C"
                      @click="removeFile3()"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </div>
            <div class="d-flex justify-end gap-16">
              <Button min-width="80px" theme="2" @onClick="editMode3 = false"
                >ยกเลิก
              </Button>

              <Button min-width="80px" theme="6" @onClick="saveActivity3"
                >ยืนยัน
              </Button>
            </div>
          </div>
        </div>
        <!-- 5.4 -->
        <div class="card-part">
          <span>{{
            "4) กิจกรรมพัฒนาทักษะและศักยภาพเบื้องต้นบุคลากรอุทยานวิทยาศาสตร์ภูมิภาค"
          }}</span>
          <div class="d-flex justify-end mb-5">
            <Button
              :disabled="editMode4 || isOIC"
              @onClick="addActivity4"
              theme="500"
              prepend-icon="mdi-plus"
              >เพิ่มกิจกรรม</Button
            >
          </div>
          <div class="card-part">
            <div
              v-if="form.step5_4 && form.step5_4.length > 0"
              class="d-flex flex-column gap-12"
            >
              <divcard
                v-for="(item, i) in form.step5_4"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{ highlighted: item.expandedForm5_4 }"
                :style="{ order: item.expandedForm5_4 ? 'orange' : 'initial' }"
                @onClick="item.expandedForm5_4 = !item.expandedForm5_4"
              >
                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="editActivity4(i)"
                  >
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>

                <div
                  class="txt-bigger flex flex-col"
                  style="min-width: 20%; max-width: 20%"
                >
                  <div>กิจกรรม</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_4 }"
                  >
                    <div>วันที่จัดกิจกรรม</div>
                    <div>สถานที่</div>
                    <div>วิทยากร</div>
                    <div>ผู้เข้าร่วม</div>
                    <div>รายละเอียดกิจกรรม</div>
                    <div>การอัพโหลดรูปภาพ</div>
                  </div>
                </div>
                <div
                  class="flex flex-col txt-bigger2"
                  style="min-width: 70%; max-width: 70%"
                >
                  <div>{{ item?.name ?? "-" }}</div>
                  <div
                    class="expandable"
                    :class="{ expanded: item.expandedForm5_4 }"
                  >
                    <div>{{ item?.date ?? "-" }}</div>
                    <div>{{ item?.location ?? "-" }}</div>
                    <div>{{ item?.lecturer ?? "-" }}</div>
                    <div>{{ item?.participant ?? "-" }}</div>
                    <div>{{ item?.description ?? "-" }}</div>
                    <div>
                      {{
                        item?.attachment?.name ||
                        item?.attachment?.file_name ||
                        "-"
                      }}
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex align-center"
                  style="min-width: 5%; max-width: 5%; height: 100%"
                >
                  <v-btn
                    v-if="!isOIC"
                    small
                    icon
                    @click.stop="deleteActivity4(i)"
                  >
                    <Iconify
                      icon="mdi:close-circle"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
              </divcard>
            </div>
            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
          <div v-if="editMode4" class="pt-6">
            <div>
              <div>
                <div class="mb-1 black--text">กิจกรรม</div>
                <TextField
                  theme="3"
                  :value="activity4New.name"
                  @onChange="activity4New.name = $event"
                >
                </TextField>
              </div>

              <div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">วันที่จัดกิจกรรม</div>
                    <DatePicker
                      theme="3"
                      input-type="number"
                      :value="activity4New.date"
                      @onInput="
                        activity4New.date = $event;
                        $forceUpdate();
                      "
                    >
                    </DatePicker>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">สถานที่</div>
                    <TextField
                      theme="3"
                      :value="activity4New.location"
                      @onChange="activity4New.location = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">วิทยากร</div>
                    <TextField
                      theme="3"
                      :value="activity4New.lecturer"
                      @onChange="activity4New.lecturer = $event"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">ผู้เข้าร่วม</div>
                    <TextField
                      theme="3"
                      :value="activity4New.participant"
                      @onChange="activity4New.participant = $event"
                    >
                    </TextField>
                  </div>
                </div>
              </div>

              <div>
                <div class="mb-1 black--text">รายละเอียดกิจกรรม</div>
                <TextArea
                  theme="3"
                  height="100"
                  :value="activity4New.description"
                  @onChange="activity4New.description = $event"
                ></TextArea>
              </div>

              <div class="mb-1 black--text">การอัพโหลดรูปภาพ</div>
              <div class="theme-color-seven mb-3">
                *ไฟล์ที่ระบบรองรับ .PNG (สูงสุด 50 mb/ไฟล์)
              </div>

              <v-layout class="mt-3">
                <template
                  v-if="
                    !activity4New.attachment?.doc_type ||
                    activity4New.attachment?.doc_type === null
                  "
                >
                  <v-flex xs7>
                    <v-file-input
                      v-model="files4"
                      :id="'file4'"
                      :rules="rulesFile"
                      color="#F15A29"
                      :clearable="false"
                      style="border-radius: 30px"
                      outlined
                      height="36"
                      placeholder=""
                      prepend-icon=""
                      accept="image/png"
                      v-show="
                        checkValType(activity4New?.attachment?.file_name) ==
                          'object' ||
                        activity4New?.attachment?.file_name == '' ||
                        activity4New?.attachment?.file_name == null
                      "
                      @change="addToAttachment4(files4)"
                    ></v-file-input>
                    <v-text-field
                      v-show="
                        checkValType(activity4New?.attachment?.file_name) ==
                        'string'
                      "
                      v-model="activity4New.attachment.file_name"
                      outlined
                      height="36"
                      color="#F15A29"
                      style="border-radius: 30px"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      dark
                      rounded
                      width="100"
                      color="#464647"
                      @click="selectFile4()"
                    >
                      <v-icon class="font-12 font-w-700" left
                        >mdi-upload</v-icon
                      >
                      <span class="font-12 font-w-700">อัพโหลด</span>
                    </v-btn>
                  </v-flex>
                  <v-flex shrink ml-3>
                    <v-btn
                      depressed
                      height="35"
                      width="35"
                      fab
                      dark
                      color="#FD0C0C"
                      @click="removeFile4()"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-flex>
                </template>
              </v-layout>
            </div>
            <div class="d-flex justify-end gap-16">
              <Button min-width="80px" theme="2" @onClick="editMode4 = false"
                >ยกเลิก
              </Button>

              <Button min-width="80px" theme="6" @onClick="saveActivity4"
                >ยืนยัน
              </Button>
            </div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import DatePicker from "../../../components/input/DatePicker";
import Button from "../../../components/input/Button.vue";
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import Wysiwyg from "../../../components/input/Wysiwyg.vue";

export default {
  name: "AFormProject",
  components: {
    DatePicker,
    Button,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    Wysiwyg,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {
        step5_1: [],
        step5_2: [],
        step5_3: [],
        step5_4: [],
      },

      editMode1: false,
      activity1New: {},
      files1: [],

      editMode2: false,
      activity2New: {},
      files2: [],

      editMode3: false,
      activity3New: {},
      files3: [],

      editMode4: false,
      activity4New: {},
      files4: [],

      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) =>
          !value || value.size <= 50000000 || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],
    };
  },
  computed: {
    ...mapState({
      ProjectForm: (state) => state.AForm.ProjectForm,
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    if (this.isSameId && !this.masterData.form_b) this.form = this.ProjectForm;
    if (this.masterData.form_b) {
      if (this.masterData.form_b.form_ab_project_info) {
        this.form = this.masterData.form_b.form_ab_project_info;

        for (let i = 1; i <= 4; i++) {
          const key = `step5_${i}`;
          const data = this.masterData.form_b.form_ab_project_info.form_f_activity?.[i] || [];
          this.$set(this.form, key, data);

          // จัดการไฟล์ ถ้ามีค่า
          if (data && typeof data === "object") {
            this[`files${i}`] = { ...data };
            if (data.file_name) {
              this[`files${i}`].file_name  = data.file_name;
            }
          }
        }
        console.log(this.form);
        const activities = this.masterData.form_b?.form_ab_project_info?.form_f_activity || {};

        Object.keys(activities).forEach((key) => {
          const data = activities[key];
          if (data) {
            this[`files${key}`] = { ...data, name: data.file_name || null };
          }
        });

      }

    }
    eventBus.$on("aFormProject", () => {
      eventBus.$emit("aFormProjectSend", this.form);
    });
  },
  methods: {
    //super function
    addActivity1() {
      this.editMode1 = true;
      this.activity1New = {
        isNew: true,
        expandedForm5_1: false,
       attachment: { file: null, file_name: null }
      };
     this.files1 = null;
    },
    saveActivity1() {
      if (!this.activity1New.isNew) {
        this.form.step5_1[this.activity1New.temp_index] = this.activity1New;
      } else {
        this.form.step5_1.push(this.activity1New);
      }
      this.files1 = null;
      this.activity1New = {};
      this.editMode1 = false;
    },
    editActivity1(i) {
      this.editMode1 = false;
      this.files1 = this.form.step5_1[i].attachment || {
        file_name: null,
      };
      this.activity1New = {
        ...this.removeVModel(this.form.step5_1[i]),
        temp_index: i,
        isNew: false,
        expandedForm5_1: false,
        attachment: this.files1,
      };
      this.editMode1 = true;
      this.$forceUpdate();
    },
    deleteActivity1(i) {
      this.form.step5_1.splice(i, 1);
      this.$forceUpdate();
    },
    //handle file
    addToAttachment1(file) {
       if (!file) return;
      if (Array.isArray(file)) file = file[0]; // ✅ กันกรณี array
      //check if file size > 10mb then show dialog modal
      const allowedTypes = [
        "image/png", // Only allow PNG files
      ];

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        this.$store.commit("General/setModal", {
          title: "ประเภทไฟล์ไม่ถูกต้อง",
          theme: "warning",
          text: "กรุณาแนบเฉพาะไฟล์ PNG",
          showCancel: false,
          buttonText: "ตกลง",
        });
        // Remove the last file
        this.activity1New.attachment = [];
        this.files1 = [];
        return;
      }

      if (file.size > 50000000) {
        this.$store.commit("General/setModal", {
          title: "ขนาดไฟล์เกิน 50 MB",
          theme: "warning",
          text: "กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB",
          showCancel: false,
          buttonText: "ตกลง",
        });
        //remove file in to last index of attachment
        this.activity1New.attachment = [];
        this.files1 = [];
        return;
      }
      console.log("file", file);
      this.activity1New.attachment = file;
      console.log("addToAttachment1", this.activity1New.attachment);
    },
    removeFile1() {
      this.activity1New.attachment = [];
      this.files1 = [];
    },
    selectFile1() {
      document.querySelector("#file").click();
    },

    //5.2
    addActivity2() {
      this.editMode2 = true;
      this.activity2New = {
        isNew: true,
        expandedForm5_2: false,
       attachment: { file: null, file_name: null }
      };
      this.files2 =  null;

    },
    saveActivity2() {
      if (!this.activity2New.isNew) {
        this.form.step5_2[this.activity2New.temp_index] = this.activity2New;
      } else {
        this.form.step5_2.push(this.activity2New);
      }
      this.files2 = null;
      this.activity2New = {};
      this.editMode2 = false;
    },
    editActivity2(i) {
      this.editMode2 = false;
      this.files2 = this.form.step5_2[i].attachment || {
        file_name: null,
      };
      this.activity2New = {
        ...this.removeVModel(this.form.step5_2[i]),
        temp_index: i,
        isNew: false,
        expandedForm5_2: false,
        attachment: this.files2,
      };

      this.editMode2 = true;
      this.$forceUpdate();
    },
    deleteActivity2(i) {
      this.form.step5_2.splice(i, 1);
      this.$forceUpdate();
    },
    //handle file
    addToAttachment2(file) {
        if (!file) return;
      if (Array.isArray(file)) file = file[0]; // ✅ กันกรณี array
      //check if file size > 10mb then show dialog modal
      const allowedTypes = [
        "image/png", // Only allow PNG files
      ];

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        this.$store.commit("General/setModal", {
          title: "ประเภทไฟล์ไม่ถูกต้อง",
          theme: "warning",
          text: "กรุณาแนบเฉพาะไฟล์ PNG",
          showCancel: false,
          buttonText: "ตกลง",
        });
        // Remove the last file
        this.activity2New.attachment = [];
        this.files2 = [];
        return;
      }

      if (file.size > 50000000) {
        this.$store.commit("General/setModal", {
          title: "ขนาดไฟล์เกิน 50 MB",
          theme: "warning",
          text: "กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB",
          showCancel: false,
          buttonText: "ตกลง",
        });
        //remove file in to last index of attachment
        this.activity2New.attachment = [];
        this.files2 = [];
        return;
      }
      this.activity2New.attachment = file;
      console.log("addToAttachment1", this.activity2New.attachment);
    },
    removeFile2() {
      this.activity2New.attachment = [];
      this.files2 = [];
    },
    selectFile2() {
      document.querySelector("#file2").click();
    },

    // 5.3
    addActivity3() {
      this.editMode3 = true;
      this.activity3New = {
        isNew: true,
        expandedForm5_3: false,
        attachment:  { file: null, file_name: null }
      };
      this.files3 =  null; 
    },
    saveActivity3() {
      if (!this.activity3New.isNew) {
        this.form.step5_3[this.activity3New.temp_index] = this.activity3New;
      } else {
        this.form.step5_3.push(this.activity3New);
      }
      this.files3 = null;
      this.activity3New = {};
      this.editMode3 = false;
    },
    editActivity3(i) {
      this.editMode3 = false;
      this.files3 = this.form.step5_3[i].attachment || {
        file_name: null,
      };
      this.activity3New = {
        ...this.removeVModel(this.form.step5_3[i]),
        temp_index: i,
        isNew: false,
        expandedForm5_3: false,
        attachment: this.files3,
      };
      this.editMode3 = true;
      this.$forceUpdate();
    },
    deleteActivity3(i) {
      this.form.step5_3.splice(i, 1);
      this.$forceUpdate();
    },
    //handle file
    addToAttachment3(file) {
       if (!file) return;
      if (Array.isArray(file)) file = file[0]; // ✅ กันกรณี array
      const allowedTypes = [
        "image/png", // Only allow PNG files
      ];

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        this.$store.commit("General/setModal", {
          title: "ประเภทไฟล์ไม่ถูกต้อง",
          theme: "warning",
          text: "กรุณาแนบเฉพาะไฟล์ PNG",
          showCancel: false,
          buttonText: "ตกลง",
        });
        // Remove the last file
        this.activity3New.attachment = [];
        this.files3 = [];
        return;
      }

      //check if file size > 10mb then show dialog modal
      if (file.size > 50000000) {
        this.$store.commit("General/setModal", {
          title: "ขนาดไฟล์เกิน 50 MB",
          theme: "warning",
          text: "กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB",
          showCancel: false,
          buttonText: "ตกลง",
        });
        //remove file in to last index of attachment
        this.activity3New.attachment = [];
        this.files3 = [];
        return;
      }
      this.activity3New.attachment = file;
      console.log("addToAttachment1", this.activity3New.attachment);
    },
    removeFile3() {
      this.activity3New.attachment = [];
      this.files3 = [];
    },
    selectFile3() {
      document.querySelector("#file3").click();
    },

    // 5.4
    addActivity4() {
      this.editMode4 = true;
      this.activity4New = {
        isNew: true,
        expandedForm5_4: false,
        attachment:  { file: null, file_name: null }
      };
      this.files4 =  null;
      
    },
    saveActivity4() {
      if (!this.activity4New.isNew) {
        this.form.step5_4[this.activity4New.temp_index] = this.activity4New;
      } else {
        this.form.step5_4.push(this.activity4New);
      }
      this.files4 = null;
      this.activity4New = {};
      this.editMode4 = false;
    },
    editActivity4(i) {
      this.editMode4 = false;
      this.files4 = this.form.step5_4[i].attachment || {
        file_name: null,
      };
      this.activity4New = {
        ...this.removeVModel(this.form.step5_4[i]),
        temp_index: i,
        isNew: false,
        expandedForm5_4: false,
        attachment: this.files4,
      };
      this.editMode4 = true;
      this.$forceUpdate();
    },
    deleteActivity4(i) {
      this.form.step5_4.splice(i, 1);
      this.$forceUpdate();
    },
    //handle file
    addToAttachment4(file) {
          if (!file) return;
      if (Array.isArray(file)) file = file[0]; // ✅ กันกรณี array
      const allowedTypes = [
        "image/png", // Only allow PNG files
      ];

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        this.$store.commit("General/setModal", {
          title: "ประเภทไฟล์ไม่ถูกต้อง",
          theme: "warning",
          text: "กรุณาแนบเฉพาะไฟล์ PNG",
          showCancel: false,
          buttonText: "ตกลง",
        });
        // Remove the last file
        this.activity4New.attachment = [];
        this.files4 = [];
        return;
      }

      //check if file size > 10mb then show dialog modal
      if (file.size > 50000000) {
        this.$store.commit("General/setModal", {
          title: "ขนาดไฟล์เกิน 50 MB",
          theme: "warning",
          text: "กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB",
          showCancel: false,
          buttonText: "ตกลง",
        });
        //remove file in to last index of attachment
        this.activity4New.attachment = [];
        this.files4 = [];
        return;
      }
      this.activity4New.attachment = file;
    },
    removeFile4() {
      this.activity4New.attachment = [];
      this.files4 = [];
    },
    selectFile4() {
      document.querySelector("#file4").click();
    },

    //end of super function

    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    checkValType(val) {
      return typeof val;
    },
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
   
  },
};
</script>

<style scoped>
.plan-card.highlighted {
  border: 2px solid #f7941d; /* Add an orange border */
  border-radius: 8px;
}
</style>
